import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="demo-video" (app/views/shared/_mapas_demo_video.html.erb): a muted looping clip with a pause
// button (WCAG 2.2.2). Under prefers-reduced-motion it stays on its poster until the visitor presses play.
export default class extends Controller<HTMLElement> {
	static targets = ["video", "button", "play", "pause"];
	declare readonly videoTarget: HTMLVideoElement;
	declare readonly buttonTarget: HTMLButtonElement;
	declare readonly playTarget: HTMLElement;
	declare readonly pauseTarget: HTMLElement;

	connect() {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) this.videoTarget.pause();
		this.sync();
	}

	toggle() {
		if (this.videoTarget.paused) void this.videoTarget.play().catch(() => {});
		else this.videoTarget.pause();
	}

	sync() {
		const paused = this.videoTarget.paused;
		this.playTarget.hidden = !paused;
		this.pauseTarget.hidden = paused;
		this.buttonTarget.setAttribute("aria-pressed", String(!paused));
	}
}
